import { render, staticRenderFns } from "./AddMyCustomer.vue?vue&type=template&id=c70c143a&scoped=true&"
import script from "./AddMyCustomer.vue?vue&type=script&lang=js&"
export * from "./AddMyCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70c143a",
  null
  
)

export default component.exports